import type { ResourceType } from "@/modules/api/resourceTypes.tsx";
import type { LbTargetType } from "@warrenio/api-spec/spec.oats.gen";

export function convertTargetType(type: LbTargetType): ResourceType {
    switch (type) {
        case "vm":
            return "virtual_machine";
    }
}
